import axios from 'axios';

export default {
  initApp(context, payload) {
    context.commit('initializeApp', payload);
  },
  loadCmsData(context) {
    fetch(`${window.cmsUrl}/wp-json/wp/v2/stations?slug=${window.cmsSlug}&lang=${context.state.lang}`)
        .then(data => data.json())
        .then(data => context.commit('loadCmsDataSuccess', data[0]))
        .catch(err => context.commit('loadCmsDataFailed', err))
  },

  startPlayer(context) {
    context.commit('updatePlayerState', true);
  },
  pausePlayer(context) {
    context.commit('updatePlayerState', false);
  },
  setCurrentPlayerTime(context, payload) {
    context.commit('updateCurrentPlayerTime', payload);
  },
  setCurrentPlayerTrack(context, payload) {
    context.commit('updateCurrentPlayerTrack', payload);
  },
  
  clickCount(context) {
    context.commit('updateClickCounter');
  },
  startStation(context) {
    context.commit('updateScreenState', 'player');
    context.commit('updateStartTimestamp', Date.now());
  },
  exitStation(context) {
    context.commit('updateScreenState', 'end');
    context.commit('updateEndTimestamp', Date.now());
  },

  getInfoPage: state => {
    if (state.cmsData)
      return state.cmsData.infobutton;
  },

  sendStatistics(context, payload) {
    context.commit('sendStatistics');
    axios
      .post(window.apiUrl + '/api/scores', {
        station_id: payload.station_id,
        visitor_id: payload.visitor_id,
        score: payload.score,
        duration: payload.duration,
        activity: payload.activity
      })
      .then(data => context.commit('sendStatisticsSuccess', data))
      .catch(err => context.commit('sendStatisticsFailed', err))
  },
};